import { render, staticRenderFns } from "./paymentModal.vue?vue&type=template&id=cb791ff2&scoped=true&"
import script from "./paymentModal.vue?vue&type=script&lang=js&"
export * from "./paymentModal.vue?vue&type=script&lang=js&"
import style0 from "./paymentModal.vue?vue&type=style&index=0&id=cb791ff2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb791ff2",
  null
  
)

export default component.exports